// extracted by mini-css-extract-plugin
export default {"success":"index_success__M0CLX","fail":"index_fail__g3kLS","missed":"index_missed__qWfNp","normal":"index_normal__j9mRH","wrap":"index_wrap__3CXeH"};